import { Action, Reducer } from 'redux';
import { UserGroupState, UserGroupTypes, UserGroupActionTypes } from './userGroupTypes';

export const INITIAL_STATE: UserGroupState = {
  usersGroup: {
    data: null,
    errorMessages: null,
    isError: false,
    isLoading: false
  }
};

const userGroupReducer: Reducer<UserGroupState> = (
  state: UserGroupState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as UserGroupActionTypes;
  switch (actionTypes.type) {
    case UserGroupTypes.GET_USERSGROUP_USER:
      return {
        ...state,
        usersGroup: { ...state.usersGroup, isLoading: true }
      };
    case UserGroupTypes.SAVE_USERSGROUP_USER:
      return {
        ...state,
        usersGroup: {
          ...state.usersGroup,
          isLoading: false,
          errorMessages: actionTypes.payload.errorMessages,
          isError: actionTypes.payload.isError,
          data: actionTypes.payload.data
        }
      };
    case UserGroupTypes.RESET_REDUCER_USERSGROUP_USER:
      return {
        ...state,
        usersGroup: INITIAL_STATE.usersGroup
      };
    default:
      return state;
  }
};

export default userGroupReducer;
